/**
 * Danger zone (platform admin only).
 *
 * Extracted from AdminSettingsPage.tsx (Sub-PR 6.3).
 */

import { useTranslation } from 'react-i18next'
import { SettingCard } from './SettingCard'

interface DangerActionProps {
  title: string
  description: string
  buttonLabel: string
}

function DangerAction({ title, description, buttonLabel }: DangerActionProps): React.ReactElement {
  return (
    <div className="flex items-center justify-between rounded-lg border border-red-200 p-4 dark:border-red-800">
      <div>
        <h4 className="text-sm font-medium text-stone-900 dark:text-stone-100">{title}</h4>
        <p className="text-xs text-stone-500 dark:text-stone-400">{description}</p>
      </div>
      <button className="rounded-lg border border-red-300 px-3 py-1.5 text-sm font-medium text-red-600 transition-colors hover:bg-red-50 dark:border-red-700 dark:text-red-400 dark:hover:bg-red-900/20">
        {buttonLabel}
      </button>
    </div>
  )
}

export function DangerZoneSection(): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <SettingCard
      title={t('adminSettings.dangerZone')}
      description={t('adminSettings.dangerZoneDesc')}
    >
      <div className="space-y-4">
        <DangerAction
          title={t('adminSettings.clearAuditLogs')}
          description={t('adminSettings.clearAuditLogsDesc')}
          buttonLabel={t('adminSettings.clearLogs')}
        />
        <DangerAction
          title={t('adminSettings.revokeAllSessions')}
          description={t('adminSettings.revokeAllSessionsDesc')}
          buttonLabel={t('adminSettings.revokeAll')}
        />
      </div>
    </SettingCard>
  )
}
